export default "/assets/website/images/route.svg?ba6703acc83713aec05f5be948dd3de6";